// NOTE: 返り値がランダムな関数はテストできないので、ランダムな部分を分離して結果の配列の長さだけテスト
export function generateRandomIndices(len: number, max: number): number[] {
  if (len === 0 || max === 0) return []
  if (len === 1) return [0]
  const randomIndices: number[] = []
  while (randomIndices.length < max && randomIndices.length < len) {
    const idx = Math.floor(Math.random() * len)
    if (!randomIndices.includes(idx)) {
      randomIndices.push(idx)
    }
  }
  return randomIndices
}

// NOTE: 返り値がランダムな関数はテストできないので、ランダムな部分を外部化して引数で渡せるようにした
export function pickItemsFrom<T>(array: T[], indices: number[]): T[] {
  return indices.map((idx) => array[idx]).filter((e) => e)
}

export function pickRandomItemsFrom<T>(array: T[], maxLength: number): T[] {
  return pickItemsFrom(array, generateRandomIndices(array.length, maxLength))
}
